// 定数
const THREE_HOURS = 3 * 60 * 60 * 1000
const KEY_PREFIX = '__giggle_cache_'

// キャッシュキーを生成する
export function generateCacheKey(...cacheIdentifiers) {
  return `${KEY_PREFIX}${cacheIdentifiers.join('_')}`
}

// キャッシュにデータを設定する
export async function setCache(key, data) {
  const now = new Date().getTime()
  const sessionStorageData = {
    data,
    expiry: now + THREE_HOURS,
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(sessionStorageData))
    return true
  } catch (error) {
    if (error.name === 'QuotaExceededError') {
      // 古いキャッシュを削除
      const keysToRemove = []
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i)
        if (key && key.startsWith(KEY_PREFIX)) {
          keysToRemove.push(key)
        }
      }
      for (const key of keysToRemove) {
        sessionStorage.removeItem(key)
      }
      // 再試行
      try {
        sessionStorage.setItem(key, JSON.stringify(sessionStorageData))
      } catch (error2) {
        return false
      }
    } else {
      return false
    }
  }
}

// キャッシュデータを取得する（値が不正の場合は null を返す）
export function getCache(key) {
  try {
    const data = sessionStorage.getItem(key)
    // 1. データの取得
    if (!data) {
      return null
    }

    // 2. データがJSONかチェック
    const item = JSON.parse(data)

    // 3. データの形式チェック(有効期限とデータ本体があるか)
    if (item.expiry === undefined || item.data === undefined) {
      throw new Error('データの形式が不正')
    }

    // 4. 有効期限のチェック
    const now = new Date().getTime()
    if (now > item.expiry) {
      throw new Error('有効期限切れ')
    }

    // データが有効な場合は返す
    return item.data
  } catch (error) {
    // エラー時はキャッシュを削除して null を返す
    sessionStorage.removeItem(key)
    return null
  }
}
